import { useMutation } from 'react-query';
import { useBrandId } from '@ux/whitelabel';
import { useRefreshBasketCount } from '@uds/bookends';
import { KnowledgeType } from '@uds/reactive-knowledge';
import makeAddToBasket from 'infrastructure/basket/addToBasket';
import { AddProductToBasketArgs } from 'core/basket';

import useShowToast from '../reactive-knowledge/useShowToast';

interface AddProductToBasketProps {
  handleAnalytics: () => void;
  postActionNavigate: () => void;
}

const useAddProductToBasket = ({ postActionNavigate, handleAnalytics }: AddProductToBasketProps) => {
  const brandId = useBrandId();
  const showToast = useShowToast();
  const refetchBasket = useRefreshBasketCount();
  const addToBasket = (items: Array<AddProductToBasketArgs>) => {
    handleAnalytics();
    return makeAddToBasket(brandId)({ items });
  };

  return useMutation(addToBasket, {
    onError: () => {
      showToast('usf.addToBasket.failure', KnowledgeType.ERK);
    },
    onSuccess: () => {
      refetchBasket();
      showToast('usf.addToBasket.success');
      postActionNavigate();
    },
  });
};

export default useAddProductToBasket;
